import React, {createContext, useContext} from 'react';

interface TabNavigationContextType {
  goHome: () => void;
  goToProfile: () => void;
}

const TabNavigationContext = createContext<TabNavigationContextType>({
  goHome: () => {},
  goToProfile: () => {},
});

export const TabNavigationProvider: React.FC<{
  goHome: () => void;
  goToProfile: () => void;
  children: React.ReactNode;
}> = ({goHome, goToProfile, children}) => (
  <TabNavigationContext.Provider value={{goHome, goToProfile}}>
    {children}
  </TabNavigationContext.Provider>
);

export const useTabNavigation = () => useContext(TabNavigationContext);
